var _path, _path2, _path3, _path4, _circle, _path5, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAxisNumbering20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.32727 1.5625L4.32727 18.4375",
    stroke: "#222627",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75586 5.30908H9.56836",
    stroke: "#00C2FF",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75586 14.6909H9.56836",
    stroke: "#00C2FF",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.136 7.55908V3.5155C15.0424 3.60909 14.8837 3.71387 14.6599 3.82983C14.4382 3.9458 14.2327 4.02718 14.0435 4.07397V3.48804C14.2937 3.41886 14.5612 3.309 14.8461 3.15845C15.1309 3.00586 15.3496 2.86243 15.5022 2.72815H15.728V7.55908H15.136Z",
    fill: "#00C2FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.2715,
    cy: 5.38721,
    r: 3.67188,
    stroke: "#00C2FF",
    strokeWidth: 0.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 13.4493C15.9996 13.195 15.9193 12.9956 15.7585 12.8512C15.5978 12.7047 15.3791 12.6315 15.1024 12.6315C14.9071 12.6315 14.7098 12.6813 14.5104 12.781C14.311 12.8807 14.1248 13.0231 13.9519 13.2083V12.6284C14.1065 12.4677 14.2815 12.3446 14.4768 12.2592C14.6742 12.1737 14.9051 12.131 15.1696 12.131C15.5968 12.131 15.9406 12.2459 16.201 12.4758C16.4615 12.7037 16.5917 13.0129 16.5917 13.4036C16.5917 13.7515 16.5113 14.0526 16.3506 14.3069C16.1919 14.5612 15.9193 14.8216 15.5327 15.0881C15.138 15.3608 14.8735 15.5561 14.7393 15.6741C14.607 15.7921 14.5144 15.905 14.4615 16.0128C14.4087 16.1206 14.3822 16.2519 14.3822 16.4065H16.7321V16.9375H13.7596V16.7025C13.7596 16.4299 13.7963 16.199 13.8695 16.0098C13.9448 15.8185 14.0679 15.6334 14.2388 15.4543C14.4097 15.2733 14.6762 15.0566 15.0383 14.8043C15.4086 14.5439 15.6609 14.316 15.7952 14.1207C15.9315 13.9234 15.9996 13.6996 15.9996 13.4493Z",
    fill: "#00C2FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.2715,
    cy: 14.7656,
    r: 3.67188,
    stroke: "#00C2FF",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxisNumbering20);
export default __webpack_public_path__ + "static/media/axis-numbering_20.a53c9e1cb9002123f8e046f05fad8db2.svg";
export { ForwardRef as ReactComponent };